import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { DatePipe } from "@angular/common";
import { DataManagementService } from "../../data-management/data-management.service";
import { Group, Vehicule } from "../../data-management/data-management.model";
import { MapService } from "../../../utils/leaflet/service/map.service";
import { GeocodingService } from "../../../utils/leaflet/service/geocoding.service";
import { imagesDir } from "../../../global.config";
import * as P from 'leaflet';
import { Subscription, Observable, Subject } from "rxjs";
import { saveAs as importedSaveAs } from "file-saver";
import { ToastrService } from "ngx-toastr";
import { resolve } from 'q';
import {Icon, LatLng, LatLngLiteral, Marker} from 'leaflet';
import { Poi } from '../../client-management.model';
import '../../../../assets/leaflet-play/dist/LeafletPlayback.js';
import { Path } from '../path/path';
import { PathService } from '../path/path.service';
declare let L: { Playback: new (arg0: P.Map, arg1: { type: string; geometry: { type: string; coordinates: any[][]; }; properties: { time: any[]; }; }, arg2: any, arg3: { playControl: boolean; dateControl: boolean; sliderControl: boolean; tracksLayer: boolean; staleTime: number; fadeMarkersWhenStale: boolean; }) => any; };


@Component({
  selector: 'app-path-poi',
  templateUrl: './path-poi.component.html',
  styleUrls: ['./path-poi.component.css']
})
export class PathPoiComponent  implements OnInit, OnDestroy {
  loaded$: Subscription;
  startDate: Date = new Date();
  endDate: Date = new Date();

  AllGroups: Subscription;
  AllPaths: Subscription;

  pathClicked: Path;

  groups: Group[];
  selectedGroup: Group = new Group();
  selectedVehicule: Vehicule = new Vehicule();
  public pathsArray: string[] = [];


  paths: Path[] = [];
  pois: Poi[];

  isResultLoaded = true;
  typicalPathName: string;
  isTableExpanded = false;
  showSpiderChart = false;
  showDetails = false;

  playback: any;

  selectedPath: any = 0;



  /** TYPICAL PATH VAR  **/
  allTypicalPath: any[] = [];
  selectedTypicalPath: any = null;
  selectedPathToCompare: any = null;

  public pointsPath: string | null = null;
  // pointsTypicalPath = null;

  isTypicalPath: boolean | null = null;
  // isLoadingTypicalPath: boolean = false;

  public polyline: any | null = null;


  isByClient = false;

  constructor(
    public dataManagementService: DataManagementService,
    private mapService: MapService,
    private geocodingService: GeocodingService,
    private pathService: PathService,
    public toastr: ToastrService,
    private datePipe: DatePipe,
    private localeService: BsLocaleService,

  ) {
    this.localeService.use('fr');

    this.startDate.setTime(this.startDate.getTime() - 3 * 86400000);
    this.startDate.setHours(0, 0, 0, 0);
    this.endDate.setHours(23, 59, 59, 59);

    this.loaded$ = this.mapService.mapLoaded.subscribe(() => {
      this.mapService.map.removeLayer(this.mapService.baseMaps.OpenStreetMap);
      this.mapService.map.addLayer(this.mapService.baseMaps['Google Sat']);
    });
  }

  ngOnInit() {

    if (this.dataManagementService.groups) {
      this.groups = this.dataManagementService.groups.filter(
        group => group.vehicules.length > 0
      );
      if (this.dataManagementService.selectedGroup) {
        this.selectedGroup = this.dataManagementService.selectedGroup;
        if (this.dataManagementService.selectedVehicule) {
          this.selectedVehicule = this.dataManagementService.selectedVehicule;
        } else if (this.selectedGroup.vehicules.length > 0) {
          this.selectedVehicule = this.selectedGroup.vehicules[0];
        }
      } else {
        if (this.groups.length > 0 && this.groups) {
          this.selectedGroup = this.groups[0];
          this.dataManagementService.selectedGroup = this.selectedGroup;
        }
      }
      this.selectedVehicule = this.dataManagementService.selectedVehicule;
    } else {
      this.AllGroups = this.dataManagementService
        .getAllGroupsDetails("")
        .subscribe(groups => {
          this.groups = groups.filter(group => group.vehicules.length > 0);
          this.dataManagementService.groups = groups;
          this.dataManagementService.setGroups(groups);
          if (this.groups.length > 0 && this.groups) {
            this.selectedGroup = this.groups[0];
            this.dataManagementService.selectedGroup = this.selectedGroup;
            if (this.selectedGroup && this.selectedGroup.vehicules.length > 0) {
              this.selectedVehicule = this.selectedGroup.vehicules[0];
              this.dataManagementService.selectedVehicule = this.selectedVehicule;
            }
          }
        });
    }

  }

  ngOnDestroy() {
    if (this.AllGroups) this.AllGroups.unsubscribe();
    if (this.AllPaths) this.AllPaths.unsubscribe();
    if(this.loaded$){this.loaded$.unsubscribe()}
  }
  distance(lat1: any, lon1: any, lat2: any, lon2: any) {
    var p = 0.017453292519943295; // Math.PI / 180
    var c = Math.cos;
    var a =
      0.5 -
      c((lat2 - lat1) * p) / 2 +
      (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;
    var distance = 12742 * Math.asin(Math.sqrt(a));
    return distance;
  }

  displayDetails(){
    if (this.showSpiderChart) {
      if (this.playback) {
        this.playback.destroy();
      }
      this.showSpiderChart = !this.showSpiderChart;
    } else {
      this.getSelectedPath(this.selectedPath);
      this.showSpiderChart = !this.showSpiderChart;
    }
  }

  getSelectedPath(path: any) {

    this.pathService
      .getPathPoiDetails(path)
      .subscribe(
        points => {
          try {
            var coordinates = points.coordinates
            var point = [];
            var times = [];

            for (var i = 0; i < coordinates.length; i++) {

              point[i] = [coordinates[i].lng, coordinates[i].lat];
              times[i] = coordinates[i].date;

            }

            var demoTracks = {
              "type": "Feature",
              "geometry": {
                "type": "MultiPoint",
                "coordinates": point
              },
              "properties": {
                "time": times
              }
            }

            // Playback options
            var playbackOptions = {
              playControl: true,
              dateControl: false,
              sliderControl: false,
              tracksLayer: false,
              staleTime: 2000,
              fadeMarkersWhenStale: true
            };


            //Initialize playback
            this.playback = new L.Playback(this.mapService.map, demoTracks, null, playbackOptions);

          } catch (error) {
          }

        });
  }

  trackingPath(path: Path) {
    if (this.selectedPath != path) {
      this.selectedPath = path;
      if (this.showSpiderChart) {
        this.getSelectedPath(this.selectedPath);
      }
    }


  }


  getDistance(latLng1: LatLngLiteral, latLng2: LatLngLiteral): number {
    var markerFrom = P.circleMarker([latLng1.lat, latLng1.lng]);
    var markerTo = P.circleMarker([latLng2.lat, latLng2.lng]);
    var from = markerFrom.getLatLng();
    var to = markerTo.getLatLng();
    var distance: number = from.distanceTo(to);
    return distance;
  }

  getAllPaths() {
    this.isResultLoaded = false;
    this.paths = [];
    this.AllPaths = this.pathService
      .getAllPoiPaths(this.selectedVehicule.idDevice, {
        startDate: this.startDate.getTime(),
        endDate: this.endDate.getTime()
      },this.isByClient)
      .subscribe(
        paths => {
          if (paths.length) {
            this.toastr.success(
              this.dataManagementService.getVehiculeName(
                this.selectedVehicule
              ) +
              " a parcouru " +
              paths.length +
              " trajets entre " +
              this.datePipe.transform(this.startDate, "dd/MM/yyyy HH:mm:ss", '', 'fr-fr') +
              " et " +
              this.datePipe.transform(this.endDate, "dd/MM/yyyy HH:mm:ss", '', 'fr-fr')
            );

            this.paths = paths;

            this.paths.forEach(path => {
              path.beginPathGeocoding = path.startAddress;

              path.endPathGeocoding = path.endAddress;

            });
          }
          this.isResultLoaded = true;
        },
        err => {
          this.isResultLoaded = true;
        }
      );
    document.getElementById("datatable-container").style.height = "auto";
    document.getElementById("datatable-container").style.overflow = "visible";
    this.isTableExpanded = true;
  }

  addPathToArray(path: any, event: any) {
    this.isTypicalPath = null;
    this.selectedPathToCompare = null;
    if (!event.ctrlKey) {
      this.pathsArray = [];
      this.mapService.removePolylinesFromMap();
      this.mapService.removeMarkersFromMap();
      if (this.playback) {
        this.playback.destroy();
      }
    }

    this.pathsArray.push(path);
    this.pointsPath = null;
    this.drawPath(path, "#0031D9").subscribe(points => {
      this.pointsPath = points;
    });
    this.trackingPath(path);
  }

  PathSelected(path: any) {
    return this.pathsArray.indexOf(path) !== -1;
  }


  drawPath(path: Path, polylineColor: string): Observable<any> {
    var subject = new Subject<any>();
    if (
      this.pathClicked == null ||
      this.pathClicked.beginPathTime !== path.beginPathTime
    ) {
      this.pathClicked = new Path();
      this.pathClicked = path;
    }

    this.pathService
      .getPathPoiDetails(path).subscribe(
        points => {
          points.stops.forEach((stop: { stopDurationStr: string; stopLatitude: number; stopLongitude: number; }) => {
            let popup =
              "<img src='" +
              imagesDir +
              "stop_smal.png" +
              "'/> Durée d'arrêt : " +
              stop.stopDurationStr;
            let stopMarker = new Marker({
              lat: stop.stopLatitude,
              lng: stop.stopLongitude
            });
            this.geocodingService
              .inverseGeoconding(stop.stopLatitude, stop.stopLongitude, 18)
              .subscribe(adress => {
                let truncatedDisplayName = adress.display_name;
                let countCommas = 0;
                for (
                  var i = 0, len = adress.display_name.length;
                  i < len;
                  i++
                ) {
                  if (adress.display_name[i] == ",") {
                    countCommas = countCommas + 1;
                  } else if (countCommas >= 4) {
                    truncatedDisplayName = adress.display_name.substring(
                      0,
                      i - 1
                    );
                    break;
                  }
                }
                popup = popup + "<br><hr><b>" + truncatedDisplayName + "</b>";
                stopMarker.bindPopup(popup);
              });
            stopMarker.setIcon(
              new Icon({
                iconUrl: imagesDir + "stop_smal.png",
                iconAnchor: [-1, 18],
                popupAnchor: [10, -25]
              })
            );
            this.mapService.addMarker(stopMarker);
          });
          this.polyline = P.polyline(points.coordinates, {
            //color: "#0031D9",
            color: polylineColor,
            weight: 3
          });
          points.coordinates.forEach((coordinate: any, i: any) => {
            let marker = new Marker(coordinate);
            if (i != 0 && i != points.coordinates.length - 1) {
              marker.setIcon(
                new Icon({
                  iconUrl: imagesDir + "green-point.png",
                  iconAnchor: [2, 2]
                })
              );
              let pointTime: any = coordinate.date;
              let coordinateTime: any = pointTime;
              coordinate.date = coordinateTime;
              var pointDatePipe = new DatePipe(coordinate.date);
              let popup =
                "<b>Heure:</b> " +
                pointDatePipe.transform(
                  coordinate.date,
                  "dd/MM/yyyy HH:mm:ss", '', 'fr-fr'
                ) +
                "<b><br>vitesse:</b> " +
                coordinate.speed +
                " Km/h";
              marker.bindPopup(popup);
              marker.on("click", () => {
                this.mapService.map.setView(coordinate, 17);
              });
              this.mapService.addMarker(marker);
            }
          });
          var startMarker = new Marker({
            lat: path.beginPathLatitude,
            lng: path.beginPathLongitude
          });
          let startTime: any = path.beginPathTime;
          var startDatePipe = new DatePipe(startTime);
          startMarker.bindPopup(
            "<b> Lieu de début: </b>" +
            this.pathClicked.beginPathGeocoding +
            "<br><b> <i>[lat: </b>" +
            path.beginPathLatitude +
            "<b> ,long: </b>" +
            path.beginPathLongitude +
            "<b>]</i><br>Temps de debut du trajet : </b>" +
            startDatePipe.transform(startTime, "dd/MM/yyyy HH:mm:ss", '', 'fr-fr')
          );
          startMarker.setIcon(
            new Icon({
              iconUrl: imagesDir + "startMarker.png",
              iconAnchor: [-2, 30],
              popupAnchor: [10, -25]
            })
          );
          this.mapService.addMarker(startMarker);
          if (
            path.endPathLatitude != null &&
            path.endPathLongitude != null &&
            path.endPathTime != null
          ) {
            var endMarker = new Marker({
              lat: path.endPathLatitude,
              lng: path.endPathLongitude
            });
            let endTime: any = path.endPathTime;
            var endDatePipe = new DatePipe(endTime);
            endMarker.bindPopup(
              "<b> Lieu de fin: </b>" +
              this.pathClicked.endPathGeocoding +
              "<br><i>[<b>lat:  </b>" +
              path.endPathLatitude +
              "<b>,long:  </b>" +
              path.endPathLongitude +
              "]</i><br><b>Temps de fin du trajet : </b>" +
              endDatePipe.transform(endTime, "dd/MM/yyyy HH:mm:ss", '', 'fr-fr') +
              "<br><b> Durée du trajet : </b>" +
              path.pathDurationStr +
              "<br><b> Durée d'arrêt : </b>" +
              path.nextStopDurationStr +
              "<br><b> Vitesse maximum : </b>" +
              path.maxSpeed +
              " Km/h <br><b> Kilometrage parcouru : </b>" +
              path.distanceDriven.toFixed(2) +
              " Km"
            );
            endMarker.setIcon(
              new Icon({
                iconUrl: imagesDir + "endMarker.png",
                iconAnchor: [-2, 30],
                popupAnchor: [10, -25]
              })
            );
            this.mapService.addMarker(endMarker);
          }
          this.mapService.addPolyline(this.polyline);
          var middle =
            points.coordinates[Math.round((points.coordinates.length - 1) / 2)];

          //map center offset(axis y)
          this.mapService.offsetMap(middle, 12, 0, -120);
          subject.next(points);
        },
        err => {
          this.toastr.error("Erreur détails trajet", "Erreur")
          subject.next(null);
        }
      );
    return subject.asObservable();
  }

  tableToggle() {
    if (this.isTableExpanded) {
      document.getElementById("datatable-container").style.height = "55px";
      document.getElementById("datatable-container").style.overflow = "hidden";
      this.isTableExpanded = false;
    } else {
      document.getElementById("datatable-container").style.height = "auto";
      document.getElementById("datatable-container").style.overflow = "visible";
      this.isTableExpanded = true;
    }
  }

  expandTable() {
    if (!this.isTableExpanded) {
      document.getElementById("datatable-container").style.height = "auto";
      document.getElementById("datatable-container").style.overflow = "visible";
      this.isTableExpanded = true;
    }
  }

  chooseGroup(group: any) {
    this.dataManagementService.selectedGroup = group;
    this.selectedGroup = group;
    if (this.selectedGroup.vehicules.length > 0 && this.selectedGroup) {
      this.selectedVehicule = this.selectedGroup.vehicules[0];
      this.dataManagementService.selectedVehicule = this.selectedVehicule;
    }
  }

  chooseVehicule(vehicule: any) {
    this.selectedVehicule = vehicule;
    this.dataManagementService.selectedVehicule = vehicule;
  }

  //==================================
  // Exporting data of Paths
  //==================================
  loader: boolean = false;
  exportPaths() {
    this.loader = true;
    let vehicule = this.pathService.getMatriculeByDeviceId(
      this.selectedGroup,
      this.selectedVehicule.idDevice
    );
    let pathToExport: Path[] = this.paths.slice();

    this.pathService
      .exportPathsPoi(
        pathToExport,
        this.selectedGroup.nom,
        this.startDate.getTime(),
        this.endDate.getTime(),
        vehicule
      )
      .subscribe(
        blob => {
          this.loader = false;
          if (blob.size != 0) importedSaveAs(blob, "LISTE_TRAJET.xlsx");
        },
        () => {
          this.loader = false;
          this.toastr.error("aucune données à exporter !", "Error");
        }
      );
  }


  pdfLoader: boolean = false;
  exportPathsPDF() {
    this.pdfLoader = true;
    let vehicule = this.pathService.getMatriculeByDeviceId(
      this.selectedGroup,
      this.selectedVehicule.device.idDevice
    );
    let pathToExport: Path[] = this.paths.slice();

    this.pathService.exportPathsPDF(pathToExport,vehicule, this.selectedGroup.nom, this.startDate.getTime(), this.endDate.getTime()).subscribe(blob => {
      if (blob.size != 0)
        importedSaveAs(blob, "LISTE_TRAJET.pdf");
        this.pdfLoader = false;
    }, () => {
      this.toastr.error('aucune données entre ces deux dates !', 'Error');
      this.pdfLoader = false;
    });
  }

  displaySavePath() {
    if (this.pathClicked != null) {
      return "visible";
    } else return "none";
  }

  displayGoogleAdress(path: Path) {
    if (path) {
      this.geocodingService
        .inverseGeocondingGoogle(
          path.beginPathLatitude,
          path.beginPathLongitude
        )
        .subscribe(response => {
          if (response && response.results[0]) {
            path.startAddress =
              response.results[0].formatted_address;
          }
        });

      this.geocodingService
        .inverseGeocondingGoogle(path.endPathLatitude, path.endPathLongitude)
        .subscribe(response => {
          if (response && response.results[0]) {
            path.endAddress =
              response.results[0].formatted_address;
          }
        });
    }
  }
}
